import {useLocalStorage} from 'usehooks-ts';

export enum PowerMode {
    RP3 = 'rp3',
    Split = 'split',
}

interface SettingValues {
    powerMode: PowerMode;
}

export interface Settings extends SettingValues {
    setPowerMode: (mode: PowerMode) => void;
}

export function useSettings(): Settings {
    const [settings, setSettings] = useLocalStorage<SettingValues>('settings', {
        powerMode: PowerMode.RP3,
    });

    return {
        powerMode: settings.powerMode,
        setPowerMode: (powerMode: PowerMode) =>
            setSettings({
                ...settings,
                powerMode,
            }),
    };
}
